<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'Routable'
}
</script>



// WEBPACK FOOTER //
// src/components/Routable.vue